import { ApiClient } from 'app/service/api-service'
import { IPayloadCreateLocationActivity, IPayloadUpdateLocationActivity } from './model'
import { LocationActivityPoint } from './constant'
export const requestPostCreateLocationActivity = (
  body: IPayloadCreateLocationActivity,
) =>
  ApiClient.Post({
    url: LocationActivityPoint.CREATE,
    body,
  })

export const requestUpdateLocationActivity = (body: IPayloadUpdateLocationActivity) =>
  ApiClient.Put({
    url: LocationActivityPoint.UPDATE,
    body,
  })

export const requestDeleteLocationActivity = (id: number) =>
  ApiClient.Put({
    url: LocationActivityPoint.DELETE,
    body: { id },
  })
